import { WhiteCircleBottomArrow } from '@randstad-lean-mobile-factory/react-components-ui-shared';
import classnames from 'classnames';

import { RawDropdown } from '../../RawDropdown';
import { BadgeDeprecated } from '../BadgeDeprecated';

import styles from './BadgeDropdown.module.scss';
import { Props } from './BadgeDropdown.types';

/**
 * @deprecated use the following instead:
 * @example import { CircleBottom } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
 *          import { Button, Menu, MenuItem } from '@randstad-lean-mobile-factory/react-components-core';
 *
 *          <Menu
 *            trigger={
 *              <Badge clickable>
 *                label
 *                <CircleBottom />
 *              </Badge>
 *            }
 *            anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
 *            transformOrigin={{ horizontal: 'right', vertical: 'top' }}
 *          >
 *            <MenuItem>item 1</MenuItem>
 *            <MenuItem>item 2</MenuItem>
 *          </Menu>
 */
export const BadgeDropdown = <T,>(props: Props<T>) => {
  const { selectedItem, keyValueExtractor } = props;
  return (
    <RawDropdown
      trigger={
        <div>
          <BadgeDeprecated
            value={selectedItem ? keyValueExtractor(selectedItem).value : 'N/A'}
            rightIcon={<WhiteCircleBottomArrow />}
            className={
              selectedItem
                ? classnames(styles.badge, keyValueExtractor(selectedItem)?.className)
                : styles.badge
            }
          />
        </div>
      }
      position="bottom right"
      {...props}
    />
  );
};
